import { SKILL_BUILDER_TYPES, SkillBuilderData } from '@services/member';
import { domainUID, skillUID } from 'jakapa-utilities-lite';

export enum ReflectionPage {
	SCORES = 'scores',
	SKILL = 'skill',
	ACTION = 'action',
	SUMMARY = 'summary',
}

export const REFLECTION_PREVIOUS_PAGE: {
	[key in ReflectionPage]?: ReflectionPage | null;
} = {};

// Start flow.
REFLECTION_PREVIOUS_PAGE[ReflectionPage.SCORES] = null;
REFLECTION_PREVIOUS_PAGE[ReflectionPage.SKILL] = ReflectionPage.SCORES;
REFLECTION_PREVIOUS_PAGE[ReflectionPage.ACTION] = ReflectionPage.SKILL;
REFLECTION_PREVIOUS_PAGE[ReflectionPage.SUMMARY] = ReflectionPage.ACTION;

export interface ReflectionSkillScores {
	uid: skillUID;
	self: number | null;
	peer: number | null;
}

export interface ReflectionData extends SkillBuilderData {
	type: SKILL_BUILDER_TYPES.REFLECTION;
	page?: ReflectionPage;
	domainUID?: domainUID;
	cycle?: number;
	scores?: Array<ReflectionSkillScores>;
	insight?: string;
	skillUID?: skillUID;
	action?: string;
	skillBuilderType?: string;
}
